<template>
  <SfButtonBase
    :variant="variant"
    :small="small"
    :disabled="disabled"
    data-testid="sf-button-inverted"
    v-bind="$attrs"
    component-type="inverted"
    @click="handleClick"
  >
    <slot></slot>
  </SfButtonBase>
</template>
<script setup lang="ts">
import SfButtonBase from './sf-button-base.vue'

defineOptions({
  name: 'SfButtonInverted',
})

interface Props {
  variant?: string
  small?: boolean
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  variant: 'primary',
  small: false,
  disabled: false,
})

const emit = defineEmits(['click'])

function handleClick(event: Event): void {
  emit('click', event)
}
</script>
